import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '../../static/image/deleteIcon.svg';
import { setValueFaqs } from '../../redux/productSlice';
import CustomInput from '../../components/customInput/CustomInput';
import CommonDeleteModal from '../../components/commonDeleteModal/CommonDeleteModal';
import CommonCKEditor from '../../components/commonCKEditor/CommonCKEditor';

const Faq = forwardRef(({ language }, ref) => {
  const dispatch = useDispatch();

  const productState = useSelector((state) => state.product);
  const product = productState.data || {};

  const faqData = product.faq || product.contentData?.faq || {};
  const faqs = faqData.items || [];
  const faqTitle = faqData.title || '';

  const [showDeleteFaqModal, setShowDeleteFaqModal] = useState(false);
  const [faqToDelete, setFaqToDelete] = useState(null);


  const PLACEHOLDER_CONFIG = {
    title: {
      EN: "Enter title in EN",
      CN: "Enter title in CN"
    },
    question: {
      EN: "Enter question in EN",
      CN: "Enter question in CN"
    },
    answer: {
      EN: "Enter answer in EN",
      CN: "Enter answer in CN"
    }
  };

  const addGroup = () => {
    const newItems = [
      ...faqs,
      { question: "", answer: "" }
    ];
    dispatch(setValueFaqs({
      value: {
        ...faqData,
        items: newItems
      }
    }));
  };

  const handleShowDeleteFaq = (index) => {
    if (faqs.length <= 1) {
      alert('At least retain one FAQ');
      return;
    }
    setFaqToDelete(index);
    setShowDeleteFaqModal(true);
  };

  const handleConfirmDeleteFaq = () => {
    if (faqToDelete !== null) {
      const newItems = faqs.filter((_, i) => i !== faqToDelete);
      dispatch(setValueFaqs({
        value: {
          ...faqData,
          items: newItems
        }
      }));
    }
    setShowDeleteFaqModal(false);
    setFaqToDelete(null);
  };

  const updateGroup = (index, field, value) => {
    const newItems = faqs.map((faq, i) =>
      i === index ? { ...faq, [field]: value } : faq
    );
    dispatch(setValueFaqs({
      value: {
        ...faqData,
        items: newItems
      }
    }));
  };

  const updateFaqTitle = (value) => {
    dispatch(setValueFaqs({
      value: {
        ...faqData,
        title: value
      }
    }));
  };



  const validateAllFaqs = () => {
    return {};
  };

  useImperativeHandle(ref, () => ({
    addGroup,
    validateAllFaqs
  }));

  return (
    <div className="tab-package-container">
      <div className="domain-group">
        <div className='package-input'>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <label>
              Title:
            </label>
          </div>
          <CustomInput
            type="text"
            value={faqTitle}
            onChange={(e) => updateFaqTitle(e.target.value)}
            placeholder={PLACEHOLDER_CONFIG.title[language]}
            customStyle={{ width: '73%' }}
          />
        </div>
      </div>

      <div
        style={{
          height: '0.5px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          margin: '25px -40px',
          width: 'calc(100% + 80px)',
          display: 'block',
          boxSizing: 'border-box'
        }}
      />

      {faqs.map((faq, index) => (
        <div key={index}>
          <div className="domain-group">
            <div className='package-input'>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <label>
                  Question:
                </label>
              </div>
              <CustomInput
                type="text"
                value={faq.question || ''}
                onChange={(e) => updateGroup(index, 'question', e.target.value)}
                placeholder={PLACEHOLDER_CONFIG.question[language]}
                customStyle={{ width: '73%' }}
              />
              <button
                className="icon-btn"
                onClick={() => handleShowDeleteFaq(index)}
              >
                <img src={DeleteIcon} alt="Delete" className="campaign-delete-icon" />
              </button>
            </div>

            <div className='package-input'>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <label>Answer:</label>
              </div>
              <div style={{ width: '73%' }}>
                <CommonCKEditor
                  data={faq.answer || ''}
                  initialValue={faq.answer || ''}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    updateGroup(index, 'answer', data);
                  }}
                />
              </div>
            </div>
          </div>


          {index !== faqs.length - 1 && (
            <div
              style={{
                height: '0.5px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                margin: '25px -40px',
                width: 'calc(100% + 80px)',
                display: 'block',
                boxSizing: 'border-box'
              }}
            />
          )
          }
        </div>
      ))}

      <CommonDeleteModal
        show={showDeleteFaqModal}
        onHide={() => {
          setShowDeleteFaqModal(false);
          setFaqToDelete(null);
        }}
        onConfirm={handleConfirmDeleteFaq}
        title="Delete FAQ"
        instruction="Are you sure you want to delete this FAQ item?"
      />

    </div>
  );
});

export default Faq;